import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
  IGSTBalances,
  IGSTPayment,
  IGSTBalancesParams,
  IGSTPaymentForm,
  IGSTPaymentHistoryParams,
  IGSTBalancesResponse,
  IGSTPaymentResponse,
  IGSTPaymentHistoryResponse,
  IGSTInvoiceBreakdownData,
  IGSTInvoiceBreakdownParams
} from "../../utils/gstSettlement.types";

/**
 * Fetch GST balances for a period
 */
export const fetchGSTBalances = createAsyncThunk(
  'gstSettlement/fetchBalances',
  async (params: IGSTBalancesParams): Promise<IGSTBalances> => {
    const response = await axios.get<IGSTBalancesResponse>(
      `/api/v1/gst-settlement/balances`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Record GST payment to government
 */
export const recordGSTPayment = createAsyncThunk(
  'gstSettlement/recordPayment',
  async (paymentData: IGSTPaymentForm): Promise<IGSTPayment> => {
    const response = await axios.post<IGSTPaymentResponse>(
      `/api/v1/gst-settlement/payment`,
      paymentData
    );
    return response.data.data;
  }
);

/**
 * Fetch GST payment history
 */
export const fetchGSTPaymentHistory = createAsyncThunk(
  'gstSettlement/fetchHistory',
  async (params?: IGSTPaymentHistoryParams): Promise<IGSTPayment[]> => {
    const response = await axios.get<IGSTPaymentHistoryResponse>(
      `/api/v1/gst-settlement/payment-history`,
      { params }
    );
    return response.data.data;
  }
);

/**
 * Fetch single GST payment by ID
 */
export const fetchGSTPaymentById = createAsyncThunk(
  'gstSettlement/fetchPaymentById',
  async (paymentId: string): Promise<IGSTPayment> => {
    const response = await axios.get<IGSTPaymentResponse>(
      `/api/v1/gst-settlement/payment/${paymentId}`
    );
    return response.data.data;
  }
);

/**
 * Fetch GST invoice breakdown (party summaries or party invoices)
 */
export const fetchGSTInvoiceBreakdown = createAsyncThunk(
  'gstSettlement/fetchInvoiceBreakdown',
  async (params: IGSTInvoiceBreakdownParams): Promise<IGSTInvoiceBreakdownData> => {
    const response = await axios.get<{ success: boolean; data: IGSTInvoiceBreakdownData }>(
      `/api/v1/gst-settlement/invoice-breakdown`,
      { params }
    );
    return response.data.data;
  }
);
